<template>
  <div name="demo-pdf-report-text">
  	pdf report text
  </div>
</template>

<script>
export default {
  name: 'demo-pdf-report-text'
}
</script>


// WEBPACK FOOTER //
// demoPdfReportText.vue?eb7dcbe6